//
// Date mixin
// ----------

define(function(require, exports, module) {
    'use strict';

    var utils = require('utils');
    var $ = require('j');

    module.exports = {

        additionalEvents: {
            'change #month': 'handleDateChange',
            'change #year': 'handleDateChange',
            'change .fn-generic-datepicker .field_name_month select': 'handleGenericDateChange',
            'change .fn-generic-datepicker .field_name_year select': 'handleGenericDateChange'
        },

        /* @deprecated
         * @removed
         * use handleDateChange
         */
        setDays: function() {
        },

        /**
         * Update days count according to chosen month
         */
        handleDateChange: function() {
            utils.checkBirthdate(this.$('#day'), this.$('#month'), this.$('#year'));
        },

        handleGenericDateChange: function(e) {

            var $parent = $(e.currentTarget).parents('.fn-generic-datepicker');

            var $day = $parent.find('.field_name_day select');
            var $month = $parent.find('.field_name_month select');
            var $year = $parent.find('.field_name_year select');

            utils.checkBirthdate($day, $month, $year);
        }
    };
});
